const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Rubric Editor Component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('rubricEditor', ['AssessmentLib', '$translate', '$sce', function (AssessmentLib, $translate, $sce) {
  return {
    restrict: 'E',
    scope: {
      question: '='
    },
    template: require('../../../templates/directives/assessments/rubric-editor.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};

      $translate([
        'edit.assessment.name_1',
        'edit.assessment.name_2',
        'edit.assessment.name_3',
        'edit.assessment.description_1',
        'edit.assessment.description_2',
        'edit.assessment.description_3'
      ]).then(function(translations) {
        self.translations = translations;
        self.info = {
          standard_rubric: {
            points: 1,
            name: '',
            description: ''
          },
          toggleRubric: function() {
            $scope.question.rubric_grading = $scope.question.rubric_grading ? false : true;
            if ($scope.question.rubric_grading) {
              if (!$scope.question.rubric_options || !$scope.question.rubric_options.length) {
                $scope.question.rubric_options = [];
                $scope.question.rubric_options.push({id: AssessmentLib.helpers.makeId(), name: $sce.valueOf(self.translations['edit.assessment.name_1']), description: $sce.valueOf(self.translations['edit.assessment.description_1']), points: 1});
                $scope.question.rubric_options.push({id: AssessmentLib.helpers.makeId(), name: $sce.valueOf(self.translations['edit.assessment.name_2']), description: $sce.valueOf(self.translations['edit.assessment.description_2']), points: 1});
                $scope.question.rubric_options.push({id: AssessmentLib.helpers.makeId(), name: $sce.valueOf(self.translations['edit.assessment.name_3']), description: $sce.valueOf(self.translations['edit.assessment.description_3']), points: 1});
              }
            }
          },
          addRubric: function() {
            // silent limit. Mental health warning if met
            if ($scope.question.rubric_options.length && $scope.question.rubric_options.length > 19) {
              return;
            }
            $scope.question.rubric_options.push(Object.assign({id: AssessmentLib.helpers.makeId()}, self.info.standard_rubric));
          },
          removeRubric: function(id) {
            if (!$scope.question.rubric_options || $scope.question.rubric_options && $scope.question.rubric_options.length < 2) {
              return;
            }

            for (var i = 0; i < $scope.question.rubric_options.length; i++) {
              if ($scope.question.rubric_options[i] && $scope.question.rubric_options[i].id === id) {
                $scope.question.rubric_options.splice(i, 1);
              }
            }
          },
          rubricPoints: function(increase, rubric) {
            if (!rubric || !rubric.id || !$scope.question.rubric_options || $scope.question.rubric_options && !$scope.question.rubric_options.length) {
              return;
            }

            for (var i = 0; i < $scope.question.rubric_options.length; i++) {
              if ($scope.question.rubric_options[i] && $scope.question.rubric_options[i].id === rubric.id) {
                var item = $scope.question.rubric_options[i];
                if (increase) {
                  item.points++;
                  return;
                }
                if (!increase) {
                  if (item.points < 2) {
                    return;
                  }
                  item.points--;
                  return;
                }
              }
            }
          },
          maxPoints: function() {
            return AssessmentLib.helpers.getQuestionValue($scope.question);
          }
        };
      });

    }],
    controllerAs: 'rubric'
  };
}]);